import * as THREE from 'three';
import {textCenter} from "../Text/TextCenter";
import {Texture} from "three";

export function DiskInternet(
    scene: THREE.Scene,
    x: number,
    z: number,
    size: number = 1.5,
    color: number = 0xEBE8F9,
    borderColor: number = 0xA890F3,
): void {
    // Disk Intérieur violet clair
    const diskGeometry = new THREE.CylinderGeometry(size, size, 0.01, 64);
    const diskMaterial = new THREE.MeshBasicMaterial({ color: color });

    // Contour violet foncé
    const diskBorderGeometry = new THREE.RingGeometry(size, size + 0.03, 64);
    const diskBorderMaterial = new THREE.MeshBasicMaterial({ color: borderColor });

    // Logo nuage
    const internetTexture = new THREE.CylinderGeometry(.8, .8, 0.001, 64);
    const texture: Texture = new THREE.TextureLoader().load('assets/three/TEXTURE/ICON_INTERNET.png' );
    const internetMaterial = new THREE.MeshBasicMaterial( { map:texture, transparent:true, color: borderColor } );

    // To Mesh
    const disk = new THREE.Mesh(diskGeometry, diskMaterial);
    const diskBorder = new THREE.Mesh(diskBorderGeometry, diskBorderMaterial);
    const diskTexture = new THREE.Mesh(internetTexture, internetMaterial);

    // Position
    diskTexture.position.y = 0.01;
    diskTexture.rotation.y = Math.PI / 2;
    diskTexture.position.z = -.5;
    diskBorder.rotation.x = -Math.PI / 2;
    diskBorder.position.set(0, 0.01, 0);

    // Group
    const diskGroup = new THREE.Group();
    diskGroup.add(disk, diskBorder, diskTexture);
    diskGroup.position.set(x, 0, z);

    // Ajout du texte
    textCenter("INTERNET", (textMesh: THREE.Mesh): void => {
        textMesh.rotation.x = -Math.PI / 2;
        textMesh.position.y = 0.01;
        textMesh.position.z = .7;
        diskGroup.add(textMesh);
    }, 0.3, borderColor, 0.01);

    scene.add(diskGroup);
}
